module.exports = __webpack_public_path__ + "img/Primary-chevron.55b3bdcc.svg";